import { Box, CircularProgress } from "@material-ui/core";
import useNutrientRatioSeries from "../../../hooks/charts/useNutrientRatioSeries";
import NutrientRatioChart from "./NutrientRatioChart";

export default function NutrientRatioChartContainer({
  startDate,
  endDate,
  locationid,
  height = 400,
}) {
  const { series, isLoading, isError } = useNutrientRatioSeries({
    startDate,
    endDate,
    locationid,
  });

  if (isLoading)
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );

  if (isError || !series?.tn_tp?.length)
    return (
      <Box
        height={height}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        No data
      </Box>
    );

  return <NutrientRatioChart series={series} height={height} />;
}
